var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemConectionsIconFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.62 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#add8e6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.36,13A6.51,6.51,0,1,0,5.84,6.51,6.52,6.52,0,0,0,12.36,13Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.36,14.23A13,13,0,0,0,.3,22.35,4.11,4.11,0,0,0,4.1,28H20.62a4.11,4.11,0,0,0,3.79-5.65A13,13,0,0,0,12.36,14.23Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25.56,14.05a5.38,5.38,0,1,0-5.38-5.38A5.39,5.39,0,0,0,25.56,14.05Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.37,21.33a10.54,10.54,0,0,0-9.81-6.61,10.42,10.42,0,0,0-3.83.72.79.79,0,0,0-.48.58.75.75,0,0,0,.27.7,14.24,14.24,0,0,1,4.11,6,3.69,3.69,0,0,1,0,2.39.72.72,0,0,0,.11.68.74.74,0,0,0,.61.31h5.8a3.44,3.44,0,0,0,3.18-4.73Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemConectionsIconFill);
export default __webpack_public_path__ + "static/media/item_conections_icon_fill.39908536910af42c6e77cd5628bd5706.svg";
export { ForwardRef as ReactComponent };